// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid[data-v-0f8464cc]{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-template-columns:repeat(auto-fill,auto);grid-gap:8px 24px;gap:8px 24px}.upper-case-first[data-v-0f8464cc]:first-letter{text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
